"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ILabelFilterable = void 0;
/* eslint-disable camelcase */
var ILabelFilterable = exports.ILabelFilterable = /*#__PURE__*/function (ILabelFilterable) {
  ILabelFilterable[ILabelFilterable["filter_payment_benefits"] = 1] = "filter_payment_benefits";
  ILabelFilterable[ILabelFilterable["filter_travel_benefits"] = 2] = "filter_travel_benefits";
  ILabelFilterable[ILabelFilterable["unfilterable"] = 3] = "unfilterable";
  return ILabelFilterable;
}({});